<template>
  <div>
    <CreateOrEditSellerQuotation
      ref="createOrEditDialog"
      @submitDialog="GetTableList"
    />
    <ImportSellerQuotation
      ref="ImportSellerQuotation"
      @submitDialog="GetTableList"
    />
    <div class="PageHeader">
      <el-breadcrumb>
        <el-breadcrumb-item> {{ l("现货管理") }} </el-breadcrumb-item>
      </el-breadcrumb>

      <div class="HeaderButtons">
        <el-button
          v-if="$store.getters.checkPermission('seller_quotation.edit')"
          type="success"
          size="small"
          @click="onlineBatch"
          >{{ l("上架") }}</el-button
        >
        <el-button
          v-if="$store.getters.checkPermission('seller_quotation.edit')"
          type="danger"
          size="small"
          @click="offlineBatch"
          >{{ l("下架") }}</el-button
        >
        <el-dropdown
          v-if="$store.getters.checkPermission('seller_quotation.add')"
          split-button
          type="primary"
          size="small"
          @click="CreateItem"
          @command="exportCommand"
        >
          <i class="el-icon-plus"></i>
          {{ l("发布现货出售") }}
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>EXCEL {{ l("批量上传") }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="PageContent">
      <el-row class="TableSearchRow" type="flex" :gutter="20">
        <el-col :span="4">
          <label>{{ l("标题") }}</label>
          <el-input
            :placeholder="l('请输入') + l('标题')"
            v-model="SearchData.title"
            clearable
            @clear="GetTableList(true)"
            @keyup.enter.native="GetTableList(true)"
          ></el-input>
        </el-col>

        <el-col :span="4">
          <label>{{ l("品质") }}</label>
          <el-select
            clearable
            v-model="SearchData.character"
            @change="GetTableList(true)"
          >
            <el-option
              v-for="item in $store.state.basicInfo.characterList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-col>

        <el-col :span="4">
          <label>{{ l("状态") }}</label>
          <el-select
            clearable
            v-model="SearchData.status"
            @change="GetTableList(true)"
          >
            <el-option
              v-for="item in statusList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-col>

        <el-col :span="4">
          <el-button
            type="primary"
            icon="el-icon-search"
            round
            @click="GetTableList(true)"
            >{{ l("查询") }}</el-button
          >
        </el-col>
      </el-row>

      <el-table
        :data="TableList"
        :stripe="true"
        @selection-change="HandleSelectionChange"
        @sort-change="HandleSortChange"
      >
        <TableOperation
          :width="80"
          :operationList="[
            {
              is_show: (row) => true,
              label: l('详情'),
              command: 'ViewItem',
            },
          ]"
          @handleOperation="HandleOperation"
        />

        <!-- {
              is_show: (row) =>
                this.$store.getters.checkPermission('seller_quotation.edit') &&
                row.status == -1,
              label: '上架',
              command: 'onlineItem',
            },
            {
              is_show: (row) =>
                this.$store.getters.checkPermission('seller_quotation.edit') &&
                row.status == 1,
              label: '下架',
              command: 'offlineItem',
            }, -->

        <el-table-column type="selection" width="55"> </el-table-column>

        <!-- <el-table-column label="图片" width="100">
          <template slot-scope="scope">
            <div class="ImageInTable">
              <el-image
                v-if="scope.row.img_array[0]"
                :src="scope.row.img_array[0]"
                fit="contain"
                :preview-src-list="scope.row.img_array"
              ></el-image>
            </div>
          </template>
        </el-table-column> -->

        <el-table-column
          prop="title"
          :label="l('标题')"
          min-width="150"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column :label="l('价格')" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <template
              v-if="scope.row.specification_amount[0].price == l('电议')"
            >
              {{ l("价格电议") }}
            </template>
            <template v-else>
              {{ scope.row.specification_amount[0].price }}{{ l("元") }}/{{
                scope.row.specification_amount[0].unit
              }}
            </template>
          </template>
        </el-table-column>

        <el-table-column :label="l('状态')" width="100">
          <template slot-scope="scope">
            <div
              :class="[
                $utils.listFilter(statusList, scope.row.status, 'class'),
              ]"
            >
              {{ $utils.listFilter(statusList, scope.row.status) }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="address"
          :label="l('发货地')"
          width="150"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column
          :label="l('询价情况')"
          width="120"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.auth_count" class="color-warning"
              >{{ scope.row.auth_count }}{{ l("家已询价") }}</span
            >
            <!-- class="ViewLink" -->
            <!-- @click="showBusiness(scope.row)" -->
            <span v-else style="color: #999">{{ l("暂无询价") }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="created_time"
          :label="l('发布日期')"
          sortable="custom"
          width="120"
        >
          <template slot-scope="scope">
            {{ scope.row.created_time.slice(0, 10) }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="HandleSizeChange"
        @current-change="HandleCurrentChange"
        :current-page="CurrentPage"
        :page-sizes="PageSizeList"
        :page-size="PageSize"
        layout="total, prev, pager, next, jumper"
        :total="TotalCount"
      ></el-pagination>
    </div>
    <el-dialog
      :title="l('询价记录')"
      :visible.sync="businessDialogVisible"
      :destroy-on-close="true"
      width="1000px"
    >
      <BusinessList v-if="businessDialogVisible" :api_url="business_api_url" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="businessDialogVisible = false">{{
          l("取 消")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tableMixin from "@/assets/js/tableMixin";
import CreateOrEditSellerQuotation from "./operation/CreateOrEditSellerQuotation.vue";
import ImportSellerQuotation from "./operation/ImportSellerQuotation.vue";
import BusinessList from "@/components/common/BusinessList.vue";

export default {
  name: "SellerQuotation",
  components: {
    CreateOrEditSellerQuotation,
    ImportSellerQuotation,
    BusinessList,
  },
  mixins: [tableMixin],
  data() {
    return {
      SearchData: {
        title: "",
        character: null,
        category_id: null,
        quality_type: null,
        status: null,
      },
      Sorting: "-updated_time",
      statusList: [
        {
          id: 1,
          name: this.l("已上架"),
          class: "color-success",
        },
        {
          id: 0,
          name: this.l("待审核"),
          class: "color-warning",
        },
        {
          id: -1,
          name: this.l("已下架"),
          class: "color-danger",
        },
      ],

      business_api_url: "",
      businessDialogVisible: false,
    };
  },
  mounted() {
    //不能放在created里，因此时dialog组件还没created
    if (this.$route.params.command) {
      if (this.$route.params.command == "create") {
        this.CreateItem();
      }
    }
  },
  methods: {
    GetTableList(resetPage) {
      if (resetPage == true) this.CurrentPage = 1;

      this.axios
        .get("/api/seller_quotation/", {
          params: {
            ...this.SearchData,
            ordering: this.Sorting,
            size: this.PageSize,
            page: this.CurrentPage,
          },
        })
        .then((data) => {
          this.TotalCount = data.count;
          this.TableList = data.results.map((item) => {
            item.img_array = JSON.parse(item.img_array);
            return item;
          });
        });
    },
    onlineItem(item) {
      this.$confirm(`${this.l("是否将")}${item.title}${this.l("上架")}?`, "", {
        type: "warning",
      }).then(() => {
        this.axios
          .put(`/api/seller_quotation/${item.code}/on/`)
          .then((response) => {
            this.GetTableList();
          });
      });
    },
    onlineBatch() {
      if (!this.MultipleSelection.length) {
        return this.$message.warning(this.l("请在列表中勾选待上架的内容"));
      }
      this.$confirm(
        `${this.l("是否将")}${this.l("选中")}${
          this.MultipleSelection.length
        }${this.l("项")}${this.l("上架")}?`,
        "",
        {
          type: "warning",
        }
      ).then(() => {
        this.axios
          .put(
            `/api/seller_quotation/bulk_on/`,
            this.MultipleSelection.map((item) => {
              return {
                code: item.code,
              };
            })
          )
          .then((response) => {
            this.GetTableList();
          });
      });
    },
    offlineItem(item) {
      this.$confirm(`${this.l("是否将")}${item.title}${this.l("下架")}?`, "", {
        type: "warning",
      }).then(() => {
        this.axios
          .put(`/api/seller_quotation/${item.code}/off/`)
          .then((response) => {
            this.GetTableList();
          });
      });
    },
    offlineBatch() {
      if (!this.MultipleSelection.length) {
        return this.$message.warning(this.l("请在列表中勾选待下架的内容"));
      }
      this.$confirm(
        `${this.l("是否将")}${this.l("选中")}${
          this.MultipleSelection.length
        }${this.l("项")}${this.l("下架")}?`,
        "",
        {
          type: "warning",
        }
      ).then(() => {
        this.axios
          .put(
            `/api/seller_quotation/bulk_off/`,
            this.MultipleSelection.map((item) => {
              return {
                code: item.code,
              };
            })
          )
          .then((response) => {
            this.GetTableList();
          });
      });
    },
    showBusiness(item) {
      this.business_api_url = `/api/seller_quotation/${item.code}/business_list/`;
      this.businessDialogVisible = true;
    },
    exportCommand() {
      this.$refs.ImportSellerQuotation.Show();
    },
  },
};
</script>


<style scoped lang="scss">
</style>

